// ABOUTME: Derives a family-wide, oldest-first pending-approval queue from already-fetched dashboard data
// ABOUTME: No backend call — enhancedDashboard.children[].choreStatuses already carries every field needed

import { ChoreListType, ChoreListStatus, EnhancedChildDashboard } from '../../types/api';

export interface ApprovalQueueItem {
  id: number;
  childId: number;
  childName: string;
  title: string;
  type: ChoreListType;
  completedAt: string;
}

export const isApprovalGated = (status: EnhancedChildDashboard['choreStatuses'][number]): boolean => {
  if (status.type === ChoreListType.Regular) return status.requiresApproval;
  return status.type === ChoreListType.MakeItRight
    || status.type === ChoreListType.ResetAndReflect
    || status.type === ChoreListType.OneOnOneTime;
};

export function buildApprovalQueue(children: EnhancedChildDashboard[]): ApprovalQueueItem[] {
  const items: ApprovalQueueItem[] = [];
  for (const child of children) {
    for (const status of child.choreStatuses) {
      if (status.status !== ChoreListStatus.PendingApproval) continue;
      if (!isApprovalGated(status)) continue;
      if (!status.completedAt) continue;
      items.push({
        id: status.id,
        childId: child.childId,
        childName: child.name,
        title: status.title,
        type: status.type,
        completedAt: status.completedAt,
      });
    }
  }
  return items.sort((a, b) => new Date(a.completedAt).getTime() - new Date(b.completedAt).getTime());
}
